export default {
  consumerInsights: 'consumerInsights',
  trendIndex: 'trend',
  trendDetail: 'trend',
  trendList: 'trend',
  marketOverview: 'marketOverview',
  topRanking: 'topRanking',
  topRankingBevol: 'topRanking',
  forProducts: 'topRanking',
  forClaims: 'topRanking',
  forBrand: 'topRanking',
  topRankingOtherWebsite: 'topRanking',
  topRankingSocialMedia: 'topRanking',
  brandList: 'brandAnalytics',
  brandDetail: 'brandAnalytics',
  productList: 'consumerProducts',
  productDetail: 'consumerProducts',
  conceptIndex: 'conceptsCollection',
  conceptDetail: 'conceptsCollection',
  newOldConcepts: 'conceptsCollection',
  conceptList: 'conceptsCollection',
  oldCconceptList: 'conceptsCollection',
  formulationList: 'formulationDesign',
  // formulationDetail: 'formulationDesign',
  formulationDetail: 'formulation_view_detail',
  ingredientSelectList: 'ingredientSelection',
  ingredientSelectDetail: 'inci_view_page',
  basfProductDetail: 'basfProduct',
  basfProductList: 'basfProduct',
  brandComparison: 'compareBrand',
  productComparison: 'compareProduct',
  formulationComparison: 'compareFormulation',
  ingredientComparison: 'compareIngredient',
  introVideo: 'video',
  introductionVideoList: 'video',
  userBehavior: 'userBehavior',
  accounts: 'accounts',
  role: 'role',
  commentData: 'userManagement',
  userGroup: 'userGroup',
  BASFProductManagement: 'BASFProductManagement',
  formulationManagement: 'formulationManagement',
  trendManagement: 'trendManagement',
  conceptManagement: 'conceptManagement',
  lifestyleSegment: 'lifestyleSegmentKeywordManagement',
  event: 'eventManagement',
  eventSpeaker: 'eventManagement',
  eventFormulationCategory: 'eventManagement',
  eventFormulation: 'eventManagement',
  eventProductCategory: 'eventManagement',
  eventConcept: 'eventManagement',
  eventProduct: 'eventManagement',
  eventTrend: 'eventManagement',
  webinar: 'webinarManagement',
  BASFProductUpload: 'BASFProductUpload',
  formulationUpload: 'formulationUpload',
  trendUpload: 'trendUpload',
  conceptUpload: 'conceptUpload',
  videoManagement: 'introductionVideo',
  otherProductList: 'topManagement',
  formuCategory: 'formulationCaategory',
  formuProduct: 'formulationBasfProduct',
  topRankForOtherWebsite: 'topRankForOtherWebsite',
  delivery: 'delivery',
  application: 'application',
  benefit: 'benefit',
  productGroup: 'productGroup',
  inciBasfMark: 'inciBasfMark',
  generalManagement: 'generalManagement',
  aboutBASF: 'aboutBASF',
  appPictures: 'appPictures',
  message: 'message',
  competitor: 'competitor',
  claim: 'claim',
  brandClaim: 'brandClaim',
  formfunction: 'formfunction',
  coownerSetting: 'coownerSetting',
  announcement: 'announcement',
  activityLog: 'activityLog',
  whiteList: 'whiteList',
  blackList: 'blackList',
  // trendDetail: 'trendDetail',
  // basfProductDetail: 'basfProductDetail',
  // formulationDetail: 'formulationDetail',
  // conceptDetail: 'conceptDetail',
  webinarManagement: 'webinar',
  qrCode: 'qrCode',
  dliteFunction: 'dliteFunction',
  basfFunction: 'basfFunction',
  bevolFunction: 'bevolFunction',
  inciManagement: 'inciManagement',
  media: 'media',
  categoryDetail: 'media',
  tagSearch: 'media',
  videoDetail: 'media',
  push: 'pushManagement',
  deeplink: 'deeplinkManagement',
  webinarClient: 'webinarClient',
  webinarDetail: 'webinarClient',
  eventList: 'webEvent',
  eventDetail: 'webEvent',
  eventFormulationList: 'webEvent',
  eventBasfProductList: 'webEvent',
  orderList: 'orderList',
  myOrder: 'basfpro_shoppingCart',
  globalPage: 'globalPage',
  commentKeywords: 'filterKeyword',
  myComparison: 'comparison',
  documentRequest: 'basfProduct',
  dlitE3X: 'myDlite',
  newVideoManagement: 'videoManagement'
}



// WEBPACK FOOTER //
// ./src/utils/resource-code.js